module.exports = __webpack_public_path__ + "img/img117.afc866af.svg";